import { createCompanyInfoInitialState } from '../PartnerSettings/PartnerSettingsSection/companyInfoDefaults';
import { normalizeWhatsAppCommunityLink } from '../../utils/whatsappCommunityLink';

const displayValue = (value) => {
  const trimmed = String(value ?? '').trim();
  return trimmed || '—';
};

const buildCommunityViewModel = (community) => {
  if (!community || typeof community !== 'object') {
    return null;
  }

  return {
    requireJoinApproval: Boolean(community.requireJoinApproval),
    attendeeEligibility: community.attendeeEligibility ?? null,
  };
};

export const buildPartnerDetailsViewModel = (partner) => {
  if (!partner) return null;

  const company = createCompanyInfoInitialState(partner);

  return {
    fullName: displayValue(company.fullName),
    shortDescription: displayValue(company.shortDescription),
    description: displayValue(company.description),
    category: displayValue(partner.category),
    logoUrl: company.logoPreview || '',
    coverUrl: company.coverPreview || '',
    websiteUrl: company.websiteUrl?.trim() || '',
    instagramUrl: company.instagramUrl?.trim() || '',
    facebookUrl: company.facebookUrl?.trim() || '',
    whatsappUrl: normalizeWhatsAppCommunityLink(company.whatsappUrl),
    community: buildCommunityViewModel(partner.community),
  };
};
